/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { tutorialesObtenerKnowledgeBase } from '../../store/actions';
import {
  Card,
  CardHeader,
  Divider,
  CardContent,
  Grid,
  Tabs,
  Tab,
  withStyles,
} from '@material-ui/core';
import { ModuleTitleUI, IconUI } from '../common';
import { TutorialesList } from './subcomponents';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class Tutoriales_ extends Component {
  state = {
    loading: {
      tutoriales: true,
      error: false,
    },
    open_tab: null,
  };

  handleChange = (event, value) => {
    this.setState({ open_tab: value });
  };

  componentDidMount() {
    this.props.tutorialesObtenerKnowledgeBase((err, resp) => {
      this.setState({
        loading: {
          ...this.state.loading,
          tutoriales: false,
          error: err ? true : false,
        },
        open_tab: this.props.tutoriales.knowledge_base_data?.length
          ? this.props.tutoriales.knowledge_base_data[0].slug
          : '',
      });
    });
  }

  render() {
    let { classes, tutoriales } = this.props;

    let tutorial_list = [];
    if (
      tutoriales.knowledge_base_data &&
      tutoriales.knowledge_base_data?.length
    ) {
      let tutorial_seleccionado = tutoriales.knowledge_base_data.filter(
        (tut) => tut.slug === this.state.open_tab
      )[0];
      if (tutorial_seleccionado) {
        tutorial_list = tutorial_seleccionado.subcategories;
      }
    }

    return (
      <WrapperLayout
        loading={this.state.loading.tutoriales}
        error={this.state.loading.error}
      >
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <ModuleTitleUI
              title="Tutoriales"
              subtitles={[
                'En esta sección te explicamos paso por paso como utilizar y sacarle el mayor provecho a Empretienda.',
              ]}
            />
            <Card className={classes.card}>
              <CardContent className={classes.card_content_tab}>
                <Tabs
                  value={this.state.open_tab}
                  onChange={this.handleChange}
                  variant="scrollable"
                  scrollButtons="on"
                  indicatorColor="primary"
                  textColor="primary"
                  classes={{
                    scrollButtons: classes.scrollButtons,
                  }}
                >
                  {tutoriales.knowledge_base_data &&
                    tutoriales.knowledge_base_data.map((ctut) => (
                      <Tab
                        key={ctut.slug}
                        label={ctut.title}
                        value={ctut.slug}
                        icon={<IconUI name={ctut.icon} />}
                      />
                    ))}
                </Tabs>
              </CardContent>
            </Card>
            {tutorial_list.map((subcategory) => {
              return (
                <Card className={classes.card_below} key={subcategory.slug}>
                  <CardHeader
                    title={subcategory.title}
                    className={classes.card_header}
                  />
                  <Divider />
                  <CardContent className={classes.card_content}>
                    <TutorialesList tutoriales={subcategory.articles} />
                  </CardContent>
                </Card>
              );
            })}
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card: theme.card.card,
  card_below: theme.card.card_below,
  card_header: theme.card.card_header,
  card_content: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  card_content_tab: {
    padding: '20px 10px',
    [theme.breakpoints.up('md')]: {
      padding: '20px 20px',
    },
  },
  scrollButtons: {
    width: 'auto',
  },
});

const mapStateToProps = (state) => {
  return {
    tutoriales: state.tutorialesKnowledgeBase,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tutorialesObtenerKnowledgeBase: (callback) =>
      dispatch(tutorialesObtenerKnowledgeBase(callback)),
  };
};

export const Tutoriales = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Tutoriales_)
);
